import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { PluginRegistry } from './plugin-registry.service';

@Component({
  selector: 'tf-plugin-extensions-outlet',
  standalone: true,
  imports: [NgComponentOutlet],
  template: `
    @for (extension of extensions(); track extension.component) {
      <ng-container *ngComponentOutlet="extension.component; inputs: inputs()" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PluginExtensionsOutletComponent {
  private readonly registry = inject(PluginRegistry);

  readonly slotId = input.required<string>();
  readonly inputs = input<Record<string, unknown>>({});

  readonly extensions = computed(() => this.registry.resolveExtensions(this.slotId()));
}
